export default __webpack_public_path__ + "static/Story_Image_6_650x650px-7a3978a6807d3b3b02b09fcbc1b0cb58.png";